// US state auto-insurance data for programmatic SEO landing pages.
// Average premiums based on 2024-2025 published data; rounded to nearest $25.
// "min_bi" = bodily injury liability per person/per accident in $thousands
// "min_pd" = property damage liability minimum in $thousands

export const STATES = [
  { code: "AL", name: "Alabama", slug: "alabama", avg: 1825, min_bi: "25/50", min_pd: 25, is_no_fault: false, notable: "Above-average uninsured driver rate (19%) drives up UM/UIM premiums." },
  { code: "AK", name: "Alaska", slug: "alaska", avg: 1325, min_bi: "50/100", min_pd: 25, is_no_fault: false, notable: "Lower population density keeps rates moderate, but rural roads raise comprehensive claims." },
  { code: "AZ", name: "Arizona", slug: "arizona", avg: 1675, min_bi: "25/50", min_pd: 15, is_no_fault: false, notable: "Phoenix and Tucson urban claims push rates ~14% above the state average." },
  { code: "AR", name: "Arkansas", slug: "arkansas", avg: 1875, min_bi: "25/50", min_pd: 25, is_no_fault: false, notable: "Frequent severe weather (hail, tornadoes) elevates comprehensive premiums statewide." },
  { code: "CA", name: "California", slug: "california", avg: 2050, min_bi: "30/60", min_pd: 15, is_no_fault: false, notable: "Prop 103 prohibits credit-based insurance pricing — clean record matters more here." },
  { code: "CO", name: "Colorado", slug: "colorado", avg: 1800, min_bi: "25/50", min_pd: 15, is_no_fault: false, notable: "Hail claims are the #1 driver of premium increases; consider comprehensive deductible adjustments." },
  { code: "CT", name: "Connecticut", slug: "connecticut", avg: 1825, min_bi: "25/50", min_pd: 25, is_no_fault: false, notable: "High repair labor rates and dense traffic raise collision premiums." },
  { code: "DE", name: "Delaware", slug: "delaware", avg: 1950, min_bi: "25/50", min_pd: 10, is_no_fault: false, notable: "PIP coverage is required ($15k minimum), bumping baseline premiums vs. neighbors." },
  { code: "DC", name: "District of Columbia", slug: "district-of-columbia", avg: 1925, min_bi: "25/50", min_pd: 10, is_no_fault: false, notable: "Urban density and high-theft ZIP codes inflate comprehensive premiums." },
  { code: "FL", name: "Florida", slug: "florida", avg: 2625, min_bi: "10/20", min_pd: 10, is_no_fault: true, notable: "No-fault state with PIP requirement. Hurricane risk + 20% uninsured drivers drive top-5 highest rates." },
  { code: "GA", name: "Georgia", slug: "georgia", avg: 1925, min_bi: "25/50", min_pd: 25, is_no_fault: false, notable: "Atlanta metro accounts for ~60% of state claims volume; suburbs pay much less." },
  { code: "HI", name: "Hawaii", slug: "hawaii", avg: 1175, min_bi: "20/40", min_pd: 10, is_no_fault: true, notable: "No-fault state. Credit score cannot be used in pricing; clean record + age drive your rate." },
  { code: "ID", name: "Idaho", slug: "idaho", avg: 1100, min_bi: "25/50", min_pd: 15, is_no_fault: false, notable: "One of the cheapest states — low population density and low litigation rates keep premiums down." },
  { code: "IL", name: "Illinois", slug: "illinois", avg: 1675, min_bi: "25/50", min_pd: 20, is_no_fault: false, notable: "Chicago metro pays nearly 2x rural Illinois — your ZIP code is the single biggest factor." },
  { code: "IN", name: "Indiana", slug: "indiana", avg: 1325, min_bi: "25/50", min_pd: 25, is_no_fault: false, notable: "Lower minimums and moderate claims keep Indiana 25% below the national average." },
  { code: "IA", name: "Iowa", slug: "iowa", avg: 1175, min_bi: "20/40", min_pd: 15, is_no_fault: false, notable: "Among the cheapest in the nation. Hail is the main premium driver; consider higher deductibles." },
  { code: "KS", name: "Kansas", slug: "kansas", avg: 1625, min_bi: "25/50", min_pd: 25, is_no_fault: true, notable: "No-fault state with PIP minimum of $4,500. Tornado/hail risk affects comprehensive." },
  { code: "KY", name: "Kentucky", slug: "kentucky", avg: 2025, min_bi: "25/50", min_pd: 25, is_no_fault: true, notable: "No-fault state — PIP minimum $10k. High medical costs push premiums above national average." },
  { code: "LA", name: "Louisiana", slug: "louisiana", avg: 2750, min_bi: "15/30", min_pd: 25, is_no_fault: false, notable: "Top-2 most expensive state. Litigation environment, hurricane risk, and direct-action statute drive rates." },
  { code: "ME", name: "Maine", slug: "maine", avg: 1000, min_bi: "50/100", min_pd: 25, is_no_fault: false, notable: "Cheapest state for auto insurance — low claims frequency despite high coverage minimums." },
  { code: "MD", name: "Maryland", slug: "maryland", avg: 1950, min_bi: "30/60", min_pd: 15, is_no_fault: false, notable: "PIP coverage required; Baltimore metro rates run 30% above state average." },
  { code: "MA", name: "Massachusetts", slug: "massachusetts", avg: 1550, min_bi: "20/40", min_pd: 5, is_no_fault: true, notable: "No-fault state. Cannot use credit, gender, education, or occupation in pricing — driving record dominates." },
  { code: "MI", name: "Michigan", slug: "michigan", avg: 2925, min_bi: "50/100", min_pd: 10, is_no_fault: true, notable: "Most expensive state historically. 2019 reform allows you to pick PIP medical limit — pick wisely to save." },
  { code: "MN", name: "Minnesota", slug: "minnesota", avg: 1500, min_bi: "30/60", min_pd: 10, is_no_fault: true, notable: "No-fault state with PIP minimum $40k. Twin Cities metro pays 25% more than greater Minnesota." },
  { code: "MS", name: "Mississippi", slug: "mississippi", avg: 1925, min_bi: "25/50", min_pd: 25, is_no_fault: false, notable: "23% uninsured driver rate (one of the highest) pushes UM/UIM premiums up." },
  { code: "MO", name: "Missouri", slug: "missouri", avg: 1750, min_bi: "25/50", min_pd: 25, is_no_fault: false, notable: "Severe weather + above-average uninsured rate keep premiums above the national average." },
  { code: "MT", name: "Montana", slug: "montana", avg: 1675, min_bi: "25/50", min_pd: 20, is_no_fault: false, notable: "Rural roads and long driving distances drive comprehensive and collision claims." },
  { code: "NE", name: "Nebraska", slug: "nebraska", avg: 1675, min_bi: "25/50", min_pd: 25, is_no_fault: false, notable: "Hail and tornado claims are the dominant factor; comprehensive coverage matters." },
  { code: "NV", name: "Nevada", slug: "nevada", avg: 2150, min_bi: "25/50", min_pd: 20, is_no_fault: false, notable: "Las Vegas metro accounts for 70% of claims; high uninsured rate (~12%) lifts premiums." },
  { code: "NH", name: "New Hampshire", slug: "new-hampshire", avg: 1100, min_bi: "25/50", min_pd: 25, is_no_fault: false, notable: "Liability insurance is not legally required (only state) — but you'll need it for any loan or lease." },
  { code: "NJ", name: "New Jersey", slug: "new-jersey", avg: 1925, min_bi: "25/50", min_pd: 25, is_no_fault: true, notable: "No-fault state with choice of basic or standard policy. Population density drives high collision rates." },
  { code: "NM", name: "New Mexico", slug: "new-mexico", avg: 1675, min_bi: "25/50", min_pd: 10, is_no_fault: false, notable: "Above-average uninsured driver rate (~21%) — UM/UIM coverage is critical here." },
  { code: "NY", name: "New York", slug: "new-york", avg: 2100, min_bi: "25/50", min_pd: 10, is_no_fault: true, notable: "No-fault state with $50k PIP minimum. NYC metro pays 60%+ more than upstate." },
  { code: "NC", name: "North Carolina", slug: "north-carolina", avg: 1175, min_bi: "30/60", min_pd: 25, is_no_fault: false, notable: "One of the cheapest states — strict rate regulation keeps premiums down." },
  { code: "ND", name: "North Dakota", slug: "north-dakota", avg: 1325, min_bi: "25/50", min_pd: 25, is_no_fault: true, notable: "No-fault state with $30k PIP. Low population density helps keep base rates moderate." },
  { code: "OH", name: "Ohio", slug: "ohio", avg: 1175, min_bi: "25/50", min_pd: 25, is_no_fault: false, notable: "Among the most affordable states — competitive insurance market and moderate claim costs." },
  { code: "OK", name: "Oklahoma", slug: "oklahoma", avg: 2025, min_bi: "25/50", min_pd: 25, is_no_fault: false, notable: "Tornado and hail risk drive premiums; comprehensive coverage is essential." },
  { code: "OR", name: "Oregon", slug: "oregon", avg: 1500, min_bi: "25/50", min_pd: 20, is_no_fault: false, notable: "PIP coverage required ($15k minimum). Portland metro rates run 25% above state average." },
  { code: "PA", name: "Pennsylvania", slug: "pennsylvania", avg: 1675, min_bi: "15/30", min_pd: 5, is_no_fault: true, notable: "Choice no-fault state. Picking full tort vs. limited tort directly affects your premium." },
  { code: "RI", name: "Rhode Island", slug: "rhode-island", avg: 2250, min_bi: "25/50", min_pd: 25, is_no_fault: false, notable: "Small state with surprisingly high rates — driven by population density and high repair costs." },
  { code: "SC", name: "South Carolina", slug: "south-carolina", avg: 1825, min_bi: "25/50", min_pd: 25, is_no_fault: false, notable: "Coastal hurricane exposure and ~10% uninsured driver rate push premiums above average." },
  { code: "SD", name: "South Dakota", slug: "south-dakota", avg: 1550, min_bi: "25/50", min_pd: 25, is_no_fault: false, notable: "Hail and tornado risk drive comprehensive claims; otherwise rates are moderate." },
  { code: "TN", name: "Tennessee", slug: "tennessee", avg: 1525, min_bi: "25/50", min_pd: 15, is_no_fault: false, notable: "Memphis and Nashville pay roughly 25% more than rural Tennessee." },
  { code: "TX", name: "Texas", slug: "texas", avg: 1825, min_bi: "30/60", min_pd: 25, is_no_fault: false, notable: "Hail, hurricanes, and dense urban metros (Houston, Dallas) keep Texas above the national average." },
  { code: "UT", name: "Utah", slug: "utah", avg: 1500, min_bi: "25/65", min_pd: 15, is_no_fault: true, notable: "No-fault state with $3k PIP minimum. Salt Lake metro accounts for most claims." },
  { code: "VT", name: "Vermont", slug: "vermont", avg: 1150, min_bi: "25/50", min_pd: 10, is_no_fault: false, notable: "Low claims frequency and rural roads keep premiums among the lowest in the country." },
  { code: "VA", name: "Virginia", slug: "virginia", avg: 1375, min_bi: "30/60", min_pd: 20, is_no_fault: false, notable: "Below-average rates statewide; uninsured motorist fee is required if you go without liability." },
  { code: "WA", name: "Washington", slug: "washington", avg: 1450, min_bi: "25/50", min_pd: 10, is_no_fault: false, notable: "Seattle metro premiums run 30% above state average; minimums are middle-of-pack." },
  { code: "WV", name: "West Virginia", slug: "west-virginia", avg: 1625, min_bi: "25/50", min_pd: 25, is_no_fault: false, notable: "Rural roads, deer collisions, and severe weather elevate comprehensive premiums." },
  { code: "WI", name: "Wisconsin", slug: "wisconsin", avg: 1275, min_bi: "25/50", min_pd: 10, is_no_fault: false, notable: "Below national average; strict insurance regulation and competitive market help drivers." },
  { code: "WY", name: "Wyoming", slug: "wyoming", avg: 1475, min_bi: "25/50", min_pd: 20, is_no_fault: false, notable: "Low population density helps base rates; comprehensive claims (wildlife, hail) are the main concern." },
];

export const NATIONAL_AVG = 1789;

// Iter-76 — Average new-car auto-loan APR by state for a 60-month term,
// 720+ FICO band, Q4 2025 published data (Experian State of the Auto
// Finance Market + cross-referenced credit-union surveys). Values rounded
// to one decimal. Drives the loans-mode interactive U.S. map color
// gradient + tooltip. NATIONAL_AVG_APR is the weighted national average
// used to compute "X% above/below national" deltas in the tooltip.
//
// Why values vary by state:
//   • Local credit-union density (Iowa, Vermont = strong; Florida = weak)
//   • Statewide loss-given-default trends (Mississippi, Louisiana high)
//   • Per-state usury caps + dealer-finance regulatory regime
//   • Captive-finance vs. bank channel share (e.g., MI captives lower)
export const STATE_LOAN_APR = {
  AL: 7.8, AK: 7.4, AZ: 7.3, AR: 8.1, CA: 7.0, CO: 7.1, CT: 7.4, DE: 7.6,
  DC: 7.3, FL: 7.9, GA: 7.7, HI: 6.9, ID: 7.0, IL: 7.3, IN: 7.2, IA: 6.7,
  KS: 7.2, KY: 7.5, LA: 8.4, ME: 6.8, MD: 7.4, MA: 7.0, MI: 7.5, MN: 6.9,
  MS: 8.6, MO: 7.6, MT: 7.1, NE: 6.9, NV: 7.5, NH: 6.8, NJ: 7.3, NM: 7.7,
  NY: 7.4, NC: 7.4, ND: 6.8, OH: 7.3, OK: 7.9, OR: 7.0, PA: 7.3, RI: 7.5,
  SC: 7.8, SD: 6.9, TN: 7.6, TX: 7.5, UT: 7.0, VT: 6.7, VA: 7.2, WA: 7.0,
  WV: 7.7, WI: 6.9, WY: 7.0,
};

export const NATIONAL_AVG_APR = 7.3;

// Iter-127 — Runtime hydration from the admin-editable state_data
// collection. The static STATES + STATE_LOAN_APR objects above remain
// the fallback (no breakage when MongoDB is empty). When the admin
// edits a value in /admin?tab=state-data, `hydrateStateOverrides()`
// mutates the in-memory copies so every consumer (rank chips, map,
// state pages, neighbor blocks) reads the fresh number on next render.
//
// Call once at app boot in App.js — same pattern as
// `hydratePartnerRouting()`.
export async function hydrateStateOverrides() {
  if (typeof window === "undefined") return;
  if (!process.env.REACT_APP_BACKEND_URL) return;
  const base = process.env.REACT_APP_BACKEND_URL.replace(/\/$/, "");
  try {
    const [insurance, loans] = await Promise.all([
      fetch(`${base}/api/state-data/insurance`).then((r) => (r.ok ? r.json() : [])),
      fetch(`${base}/api/state-data/auto-loan`).then((r) => (r.ok ? r.json() : [])),
    ]);
    if (Array.isArray(insurance)) {
      insurance.forEach((row) => {
        const target = STATES.find((s) => s.code === row.code);
        if (target && typeof row.value === "number") {
          target.avg = Math.round(row.value);
        }
      });
    }
    if (Array.isArray(loans)) {
      loans.forEach((row) => {
        if (typeof row.value === "number") {
          STATE_LOAN_APR[row.code] = Number(row.value);
        }
      });
    }
  } catch {
    /* fall back to static defaults; never block the app on a perf miss */
  }
}

export const findStateApr = (code) => STATE_LOAN_APR[code] ?? NATIONAL_AVG_APR;

export const findState = (slug) => STATES.find((s) => s.slug === slug);

// Iter-64: lookup by 2-letter code, used by useDetectedState() to map
// the backend `/api/geo` response (which returns ISO-3166-2 codes) to a
// full state object.
export const findStateByCode = (code) =>
  STATES.find((s) => s.code === (code || "").toUpperCase());

// Iter-121 — Geographic adjacency map for internal-linking uniqueness on
// per-state pages. Each state gets 3-5 nearest geographic neighbors —
// the set is unique per state so each InsuranceStatePage / AutoLoanStatePage has
// a distinct "compare neighbors" block (eliminates duplicate-content
// risk that came from the generic "first 20 states" list previously
// rendered on every page).
//
// Pacific/island states (AK, HI) lack land neighbors → mapped to
// Pacific-coast peers so the comparative block still has signal.
export const STATE_NEIGHBORS = {
  AL: ["mississippi", "georgia", "florida", "tennessee"],
  AK: ["washington", "oregon", "hawaii", "california"],
  AZ: ["california", "nevada", "new-mexico", "utah"],
  AR: ["missouri", "tennessee", "mississippi", "louisiana"],
  CA: ["oregon", "nevada", "arizona", "washington"],
  CO: ["wyoming", "kansas", "new-mexico", "utah"],
  CT: ["massachusetts", "new-york", "rhode-island", "new-jersey"],
  DE: ["maryland", "new-jersey", "pennsylvania", "virginia"],
  DC: ["maryland", "virginia", "delaware", "pennsylvania"],
  FL: ["georgia", "alabama", "south-carolina", "north-carolina"],
  GA: ["florida", "alabama", "tennessee", "south-carolina"],
  HI: ["california", "oregon", "washington", "alaska"],
  ID: ["montana", "wyoming", "utah", "oregon"],
  IL: ["wisconsin", "indiana", "missouri", "iowa"],
  IN: ["illinois", "kentucky", "ohio", "michigan"],
  IA: ["minnesota", "wisconsin", "illinois", "nebraska"],
  KS: ["nebraska", "missouri", "oklahoma", "colorado"],
  KY: ["indiana", "ohio", "west-virginia", "tennessee"],
  LA: ["texas", "arkansas", "mississippi", "alabama"],
  ME: ["new-hampshire", "massachusetts", "vermont", "new-york"],
  MD: ["delaware", "pennsylvania", "virginia", "west-virginia"],
  MA: ["connecticut", "new-york", "new-hampshire", "rhode-island"],
  MI: ["ohio", "indiana", "wisconsin", "illinois"],
  MN: ["wisconsin", "iowa", "north-dakota", "south-dakota"],
  MS: ["louisiana", "arkansas", "tennessee", "alabama"],
  MO: ["iowa", "illinois", "kentucky", "arkansas"],
  MT: ["idaho", "wyoming", "north-dakota", "south-dakota"],
  NE: ["south-dakota", "iowa", "missouri", "kansas"],
  NV: ["california", "oregon", "idaho", "arizona"],
  NH: ["maine", "massachusetts", "vermont", "connecticut"],
  NJ: ["new-york", "pennsylvania", "delaware", "connecticut"],
  NM: ["colorado", "oklahoma", "texas", "arizona"],
  NY: ["vermont", "massachusetts", "connecticut", "pennsylvania"],
  NC: ["virginia", "tennessee", "georgia", "south-carolina"],
  ND: ["montana", "south-dakota", "minnesota", "wyoming"],
  OH: ["michigan", "indiana", "kentucky", "pennsylvania"],
  OK: ["kansas", "missouri", "arkansas", "texas"],
  OR: ["washington", "idaho", "california", "nevada"],
  PA: ["new-york", "new-jersey", "delaware", "ohio"],
  RI: ["connecticut", "massachusetts", "new-york", "new-hampshire"],
  SC: ["north-carolina", "georgia", "tennessee", "florida"],
  SD: ["north-dakota", "minnesota", "nebraska", "wyoming"],
  TN: ["kentucky", "virginia", "north-carolina", "georgia"],
  TX: ["new-mexico", "oklahoma", "arkansas", "louisiana"],
  UT: ["idaho", "wyoming", "colorado", "nevada"],
  VT: ["new-york", "massachusetts", "new-hampshire", "maine"],
  VA: ["maryland", "north-carolina", "tennessee", "west-virginia"],
  WA: ["oregon", "idaho", "california", "montana"],
  WV: ["kentucky", "ohio", "pennsylvania", "virginia"],
  WI: ["minnesota", "iowa", "illinois", "michigan"],
  WY: ["montana", "south-dakota", "nebraska", "colorado"],
};

export const getStateNeighbors = (code) => {
  const slugs = STATE_NEIGHBORS[(code || "").toUpperCase()] || [];
  return slugs.map((slug) => STATES.find((s) => s.slug === slug)).filter(Boolean);
};

// Iter-121 — National rank helpers. Each state page surfaces a unique
// rank phrase ("#3 cheapest" / "#48 most expensive") in its title, H1,
// hero, and meta description — eliminating duplicate-content risk that
// previously came from a uniform template across all 51 state URLs.
const _ordinal = (n) => {
  const s = ["th", "st", "nd", "rd"];
  const v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
};

export const stateOrdinal = _ordinal;

// Insurance: rank by `avg` ASCENDING (1 = cheapest).
const _insuranceRanks = (() => {
  const sorted = [...STATES].sort((a, b) => a.avg - b.avg);
  const m = {};
  sorted.forEach((s, i) => {
    m[s.code] = i + 1;
  });
  return m;
})();

export const getInsuranceRank = (code) => {
  const total = STATES.length;
  const rank = _insuranceRanks[code] || total;
  // Top-half rank = "cheap"; otherwise "expensive".
  const isCheap = rank <= Math.ceil(total / 2);
  const distance = isCheap ? rank : total - rank + 1;
  return {
    rank,
    total,
    ordinal: _ordinal(rank),
    isCheap,
    distance,
    distanceOrdinal: _ordinal(distance),
  };
};

// Auto-loan APR: rank by `apr` ASCENDING (1 = lowest APR).
const _aprRanks = (() => {
  const codes = STATES.map((s) => s.code);
  const sorted = [...codes].sort(
    (a, b) => (STATE_LOAN_APR[a] ?? 99) - (STATE_LOAN_APR[b] ?? 99),
  );
  const m = {};
  sorted.forEach((c, i) => {
    m[c] = i + 1;
  });
  return m;
})();

export const getLoanAprRank = (code) => {
  const total = STATES.length;
  const rank = _aprRanks[code] || total;
  const isLow = rank <= Math.ceil(total / 2);
  const distance = isLow ? rank : total - rank + 1;
  return {
    rank,
    total,
    ordinal: _ordinal(rank),
    isLow,
    distance,
    distanceOrdinal: _ordinal(distance),
  };
};
